import React from 'react';
import styles from './ErrorMessage.module.scss';
import Text from '../../../Text';

interface Props {
	tx: string;
}

const ErrorMessage = ({ tx }: Props) => (
	<div className={styles.errorMessage}>
		<Text tx={tx} inline />
	</div>
);

export default ErrorMessage;
